import styled from 'styled-components'

const StyledUnknownWordsTimestampsContainer = styled.div`
  margin-top: 0.25rem;
`

export default StyledUnknownWordsTimestampsContainer
